// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"18022556","331":"aa51ccbd","642":"6e46aa48","855":"14661d1b","971":"27614bbc"}[chunkId] + ".chunk.js";
};